<template>
  <div>
    <div class="form-row">
      <v-select
        v-model="address.country_id"
        outline
        label="Country"
        :rules="[v => !!v || 'This field is required' ]"
        :items="countries"
        item-value="iso"
        item-text="name"
        @change="onChangeCountry"
      />
    </div>
    <div v-if="address.country_id == 'lu'">
      <div layout="row">
        <v-menu
          v-model="menuVisible"
          :close-on-content-click="false"
          :nudge-width="200"
          :offset-y="true"
          max-height="300"
          open-on-focus
          transition="fade-transition"
        >
          <template #activator="{ on }">
            <v-text-field
              ref="searchField"
              v-model="search"
              label="Rechercher une rue luxembourgeoise"
              :loading="loading"
              clearable
              hide-details
              :disabled="ignore_lux_cities"
              @input="onSearchInput"
              @focus="menuVisible = true"
              v-on="on"
            />
          </template>
          <v-card flat>
            <v-list v-if="streets.length > 0">
              <v-list-tile
                v-for="street in streets"
                :key="street.id"
                @click="onStreetSelected(street)"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ street.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list v-else>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Aucun résultat</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </div>
      <div
        layout="row"
        style="margin-bottom: 20px"
      >
        <v-checkbox
          v-model="ignore_lux_cities"
          label="Je n'ai pas trouvé l'adresse"
          hide-details
          @change="onChangeIgnoreLuxCities"
        />
      </div>
    </div>

    <div layout="row">
      <v-text-field
        v-model="address.number"
        outline
        label="Number"
        class="mr-1"
        :rules="[v => !!v || 'This street number is required' ]"
        @change="$emit('update', address)"
      />
      <v-text-field
        v-model="address.street"
        outline
        label="Street"
        class="ml-1"
        :readonly="!ignore_lux_cities"
        @change="$emit('update', address)"
      />
    </div>

    <div layout="row">
      <v-text-field
        v-model="address.zip_code"
        outline
        label="ZIP Code"
        class="mr-1"
        :readonly="!ignore_lux_cities"
        @change="$emit('update', address)"
      />
      <v-text-field
        v-model="address.city"
        outline
        label="City"
        class="ml-1"
        :readonly="!ignore_lux_cities"
        @change="$emit('update', address)"
      />
    </div>
  </div>
</template>
<script>
  import Params from "@/api/params"
  export default {
    props: {
      addressable: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        address: {
          country_id: null,
          city_id: null,
          street_id: null,
          number: '',
          street: '',
          zip_code: '',
          city: ''
        },
        menuVisible: false,
        ignore_lux_cities: false,
        countries: [],
        streets: [],
        search: '',
        searchTimeout: null,
        loading: false
      }
    },
    async mounted() {
      this.address.country_id = this.addressable.country_id
      this.address.city_id = this.addressable.city_id
      this.address.street_id = this.addressable.street_id
      this.address.by_pass_lux = this.addressable.by_pass_lux
      this.address.number = this.addressable.number
      this.address.street = this.addressable.street
      this.address.zip_code = this.addressable.zip_code
      this.address.city = this.addressable.city

      this.ignore_lux_cities = this.address.country_id != 'lu' || ! this.address.street_id

      const {data: countries} = await Params.getList("countries", {sortBy: "name"})
      this.countries = countries
    },
    methods: {
      onChangeCountry() {
        if(this.address.country_id == 'lu') {
          this.ignore_lux_cities = false
        }
        else {
          this.ignore_lux_cities = true
          this.address.city_id = null
          this.address.street_id = null
        }
        this.$emit("update", this.address)
      },
      onSearchInput(val) {
        if (!val || val.length < 3) {
          this.streets = [];
          this.menuVisible = false;
          return;
        }

        this.loading = true;
        this.menuVisible = true
        clearTimeout(this.searchTimeout) //debounce

        this.searchTimeout = setTimeout(() => {
          this.onSearchStreet(val)
        }, 500)
      },
      async onSearchStreet(search) {
        this.streets.splice(0)
        const {data} = await Params.getList("streets", {search})
        this.streets.push(...data)
        this.loading = false
      },
      onStreetSelected(street) {
        this.address.street_id = street.id ?? null
        if(this.address.street_id) {
          this.address.city_id = street.city_id
          this.address.street = street.streetname
          this.address.zip_code = street.postalcode
          this.address.city = street.cityname
        }
        else {
          this.address.city_id = null
          this.address.street = ""
          this.address.zip_code = ""
          this.address.city = null
        }

        this.$emit("update", this.address)

        this.search = street.name;
        this.menuVisible = false;
      },
      onChangeIgnoreLuxCities() {
        this.address.street_id = null
        this.address.city_id = null
        this.$emit("update", this.address)
      }
    }
  }
</script>
